import { Injectable } from '@angular/core';
import { Job } from '@apply4u/models/search/job';
import { ProfileInformations } from '@apply4u/models/user-profile/profile-informations';
import { ConnectionAlreadyRequested, ConnectionBlocked, ConnectionDeleted, ConnectionRejected, ConnectionRequested, UserAlreadyConnected } from '@apply4u/shared/constant/messages/common-notifications';
import { IsNotNull } from '@apply4u/shared/helpers/common/type-safe-helpers';
import { Observable } from 'rxjs';
import { ConnectionResults } from '../models/connectionResults';
import { UserConnection } from '../models/userConnection';
import { ContextService } from './context-service';
import { HttpClientWrapper } from './httpclientwrapper';
import { LoadingService } from './loading.service';
import { ToasterMessageService } from './toaster-message.service';

@Injectable({
    providedIn: 'root'
})
export class UserConnectionService {
    constructor(private http: HttpClientWrapper,
        private toasterService: ToasterMessageService,
        private loadingService: LoadingService,
        private ContextService: ContextService) {
    }

    GetUserConnectionAsync(Id: number): Observable<UserConnection> {
        return this.http.GetAsync<UserConnection>(this.http.BaseUrl + "api/UserConnection/" + Id);
    }

    GetUserConnectionsAsync(userId: number = null,
        connectedToUserId: number = null,
        statusId: number = null,
        invitationGuid: string = null,
        isActive: boolean = null): Observable<UserConnection[]> {
        let requestParams = "?";

        if (userId !== undefined && userId != null && userId > 0) {
            requestParams += "userId=" + userId;
        }

        if (connectedToUserId !== undefined && connectedToUserId != null && connectedToUserId > 0) {
            requestParams += (requestParams == "?" ? "" : "&") + "connectedToUserId=" + connectedToUserId;
        }

        if (statusId !== undefined && statusId != null && statusId > 0) {
            requestParams += (requestParams == "?" ? "" : "&") + "statusId=" + statusId;
        }

        if (invitationGuid !== undefined && invitationGuid != null && invitationGuid != "") {
            requestParams += (requestParams == "?" ? "" : "&") + "invitationGuid=" + invitationGuid;
        }

        if (isActive !== undefined && isActive != null && isActive != false) {
            requestParams += (requestParams == "?" ? "" : "&") + "isActive=" + isActive;
        }

        if (requestParams == "?") {
            requestParams = "";
        }

        return this.http.GetAsync<UserConnection[]>(this.http.BaseUrl + "api/UserConnection/search" + requestParams);
    }

    GetUserConnectionsRequestsAsync(userId: number, statusId: number, pageNumber: number,pageSize: number): Observable<UserConnection[]> {
        return this.http.GetAsync<UserConnection[]>(`${this.http.BaseUrl}api/UserConnection/connnectionRequests?userId=${userId}&statusId=${statusId}&pageNumber=${pageNumber}&pageSize=${pageSize}`);
    }

    GetUserPendingRequests(userId: number, pageNumber: number,pageSize: number): Observable<UserConnection[]> {
        return this.http.GetAsync<UserConnection[]>(`${this.http.BaseUrl}api/UserConnection/pendingRequest?userId=${userId}&pageNumber=${pageNumber}&pageSize=${pageSize}`);
    }
    GetUserConnectedAsync(userId: number = null, connectedToUserId: number = null): Observable<UserConnection[]> {
        return this.http.GetAsync<UserConnection[]>(this.http.BaseUrl + "api/UserConnection/search/connected?userId=" + userId + "&connectedToUserId=" + connectedToUserId);
    }

    GetSuggestedConnectionsAsync(userId: number, pageNumber: number,pageSize: number): Observable<ConnectionResults> {
        let urlParam = "?";

        if (userId !== undefined && userId != null && userId > 0) {
            urlParam += (urlParam == "?" ? "" : "&") + "userId=" + userId;
        }

        if (pageNumber !== undefined && pageNumber != null && pageNumber != 0) {
            urlParam += (urlParam == "?" ? "" : "&") + "pageNumber=" + pageNumber;
        }

        if (pageSize !== undefined && pageSize != null && pageSize != 0) {
            urlParam += (urlParam == "?" ? "" : "&") + "pageSize=" + pageSize;
        }

        if (urlParam == "?") {
            urlParam = "";
        }

        return this.http.GetAsync<ConnectionResults>(this.http.BaseUrl + "api/UserConnection/suggestedConnections" + urlParam);
    }

    SaveUserConnectionAsync(userConnection: UserConnection): Observable<any> {
        return this.http.PostAsync(this.http.BaseUrl + "api/UserConnection", userConnection);
    }

    SaveUserConnectionNewAsync(userConnection: UserConnection): Observable<UserConnection> {
        return this.http.PostAsync(this.http.BaseUrl + "api/UserConnection/new", userConnection);
    }

    UpdateUserConnectionAsync(userConnection: UserConnection): Observable<any> {
        return this.http.PutAsync(this.http.BaseUrl + "api/UserConnection/userConnectionId?userConnectionId=" + userConnection.Id, userConnection);
    }

    BlockUserConnectionAsync(userId: number, connectionId: number): Observable<any> {
      return this.http.GetAsync(this.http.TransmitterApiBaseUrl + `api/User/${userId}/UserConnection/Block?connectionId=${connectionId}`);
    }

    UnblockUserConnectionAsync(userId: number, connectionId: number): Observable<any> {
      return this.http.GetAsync(this.http.TransmitterApiBaseUrl + `api/User/${userId}/UserConnection/Unblock?connectionId=${connectionId}`);
    }

    DeleteConnnectionAsync(id: number): Observable<any> {
        return this.http.DeleteAsync(this.http.BaseUrl + "api/UserConnection/userConnectionId?userConnectionId=" + id);
    }
    
    GetUserChatConnectionAsync(userId: number = null): Observable<UserConnection[]> {
        return this.http.GetAsync<UserConnection[]>(this.http.BaseUrl + "/api/UserConnection/chatConnection?userId=" + userId);
    }

    ConnectToJobPostedUser(job: Job): void {
        if (this.ContextService.IsUserLoggedIn == false) {
          this.toasterService.LoginMessageError();
          return;
        }
    
        if (job.UserConnectionStatusId == 3) {
          this.toasterService.Error(null, ConnectionAlreadyRequested);
        } else {
          let userConnection = new UserConnection();
          userConnection.UserId = this.ContextService.LoggedInUserId;
          userConnection.ConnectedToUserId = job.PostedByUserId;
          userConnection.StatusId = 3;
          userConnection.IsActive = true;
    
          this.loadingService.Show();
    
          this.SaveUserConnectionNewAsync(userConnection).subscribe({
            next: result => {
                this.loadingService.Hide();
        
                if (IsNotNull(result)) {
                  job.UserConnectionStatusId = result.StatusId;
                  job.UserConnectionId = result.Id;
        
                  if (result.StatusId == 1) {
                    this.toasterService.Error(null, UserAlreadyConnected);
                  } else if (result.StatusId == 2) {
                    this.toasterService.Error(null, ConnectionRejected);
                  } else if (result.StatusId == 3) {
                    this.toasterService.Success(null, ConnectionRequested);
                  } else if (result.StatusId == 4) {
                    this.toasterService.Error(null, ConnectionBlocked);
                  }
                }
              },
              error: error => {
                this.loadingService.Hide();
                this.toasterService.ServerError();
              }
          });
        }
      }
    
      CancelConnectionRequestWithJobPostedUser(job: Job): void {
        if (this.ContextService.IsUserLoggedIn == false) {
          this.toasterService.LoginMessageError();
          return;
        }
    
        this.loadingService.Show();
    
        this.DeleteConnnectionAsync(job.UserConnectionId).subscribe({
            next: result => {
                this.toasterService.Success(null, ConnectionDeleted);
                this.loadingService.Hide();
                job.UserConnectionId = 0;
                job.UserConnectionStatusId = 0;
              },
              error: error => {
                this.loadingService.Hide();
                this.toasterService.ServerError();
              }
          });
      }
  ConnectToUser(profileInformations: ProfileInformations): void {
    if (this.ContextService.IsUserLoggedIn == false) {
      this.toasterService.LoginMessageError();
      return;
    }

    if (profileInformations.UserConnectionStatusId == 3) {
      this.toasterService.Error(null, ConnectionAlreadyRequested);
    } else {
      let userConnection = new UserConnection();
      userConnection.UserId = this.ContextService.LoggedInUserId;
      userConnection.ConnectedToUserId = profileInformations.UserProfile.UserId;
      userConnection.StatusId = 3;
      userConnection.IsActive = true;

      this.loadingService.Show();

      this.SaveUserConnectionNewAsync(userConnection).subscribe({
        next: result => {
          this.loadingService.Hide();

          if (IsNotNull(result)) {
            profileInformations.UserConnectionStatusId = result.StatusId;
            profileInformations.UserConnectionId = result.Id;

            if (result.StatusId == 1) {
              this.toasterService.Error(null, UserAlreadyConnected);
            } else if (result.StatusId == 2) {
              this.toasterService.Error(null, ConnectionRejected);
            } else if (result.StatusId == 3) {
              this.toasterService.Success(null, ConnectionRequested);
            } else if (result.StatusId == 4) {
              this.toasterService.Error(null, ConnectionBlocked);
            }
          }
        },
        error: error => {
          this.loadingService.Hide();
          this.toasterService.ServerError();
        }
      });
    }
  }

  CancelConnectionRequestWithUser(profileInformations: ProfileInformations): void {
    if (this.ContextService.IsUserLoggedIn == false) {
      this.toasterService.LoginMessageError();
      return;
    }

    this.loadingService.Show();

    this.DeleteConnnectionAsync(profileInformations.UserConnectionId).subscribe({
      next: result => {
        this.toasterService.Success(null, ConnectionDeleted);
        this.loadingService.Hide();
        profileInformations.UserConnectionId = 0;
        profileInformations.UserConnectionStatusId = 0;
      },
      error: error => {
        this.loadingService.Hide();
        this.toasterService.ServerError();
      }
    });
  }
}
